import {announce} from '@github-ui/aria-live'
import {useClosePullRequestMutation} from '@github-ui/mergebox/use-close-pull-request-mutation'
import {GitPullRequestClosedIcon} from '@primer/octicons-react'
import {ActionList} from '@primer/react'
import {FailureDialog} from './FailureDialog'
import {useInvalidatePrState} from '../data/use-invalidate-pr-state'
import {PullRequestState} from '../../../types'

export function CloseAction() {
  const invalidatePrState = useInvalidatePrState()

  const closeMutation = useClosePullRequestMutation({
    onSuccess: () => {
      announce('Pull request closed')
      invalidatePrState(PullRequestState.Closed)
    },
  })

  return (
    <>
      <ActionList.Item variant="danger" loading={closeMutation.isPending} onSelect={() => closeMutation.mutate()}>
        <ActionList.LeadingVisual>
          <GitPullRequestClosedIcon />
        </ActionList.LeadingVisual>
        Close pull request
      </ActionList.Item>

      {closeMutation.isError && (
        <FailureDialog
          title="Failed to close pull request"
          message="An error occurred while closing this pull request. Please try again."
          details={closeMutation.error.message}
          onRetry={() => closeMutation.mutate()}
          onDismiss={() => closeMutation.reset()}
        />
      )}
    </>
  )
}
